import { Injectable, OnInit } from "@angular/core";
import { SideBarService } from "../../../shared/services/sideBarService";

@Injectable()
export class GlobalAlertMainComponent implements OnInit {
  constructor(private sideBarService: SideBarService) {}

  ngOnInit(): void {
    this.sideBarService.setItems([
      { Text: "Global Alert", Url: "/editorialtools/globalalert" },
      { Text: "Scheduled", Url: "/editorialtools/scheduled" },
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/editorialtools/components/scripts/main.component.ts